<script lang="ts">
	import { EditionDrop } from '#lib/websites/editions/pages/EditionDrop/index.js';
</script>

<EditionDrop />
